export enum BannerType {
    IrisUpsell = 'IrisUpsell',
    EdgeUpsell = 'EdgeUpsell',
    OWAMailHandlerUpsell = 'OWAMailHandlerUpsell',
    None = '',
}
